/** Comma-separate values; show at most `maxVisible`, then append "..." */
export function formatGroupedValues(values, formatLabel = (v) => v, maxVisible = 3) {
  if (!Array.isArray(values) || values.length === 0) return "";
  const labels = values.map((v) => formatLabel(v));
  if (labels.length <= maxVisible) return labels.join(", ");
  return `${labels.slice(0, maxVisible).join(", ")}...`;
}

export default formatGroupedValues;
